


































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import { http as _http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import DataTableComponents from "@/components/App/Assets/Card/Body/CardType/DataTable/SimpleDataTable.vue";
@Component({
  components: {
    DataTableComponents,
  }
})
export default class GrantGridViewComponent extends Vue {
    @Prop() grants: Array<any>;
    @Prop() accessRights: any;
    filterByKey = '';

    mounted() {
    // this.resetAppState();
    let rootState = this.$store.state;
    let payload = this.$store.state.dashboard;
    let componentName = "grantIndex";

    let header = [], fieldsList = [];

    //#.Filter component enabled.
    if (payload.template.filter == true) {
      payload.cards.push("FilterComponent");
      payload.title.push("Filter");
    }

    // @ts-ignore
    _.forOwn(rootState[componentName].fields, function (key, val) {
      if (
        key.primaryKey != true &&
        key.parent != true &&
        key.list != false &&
        key.type != "Hidden"
      ) {
        if (!key.orgTitle) key.orgTitle = key.title;

        if (payload.keyTranslator) key.text = key.orgTitle;
        else key.text = key.title;

        key.title = key.text;
        // @ts-ignore
        header.push(key);
      }

      if (
        !key.primaryKey &&
        key.type != "Hidden" &&
        !key.create &&
        !key.parent
      ) {
        // @ts-ignore
        fieldsList.push(key.value);
      }
    });

    rootState[componentName].headers = header;

    // this.callProposalCallFilter("");

    // @ts-ignore
    this.$store.dispatch("load", this.$store.state["grantIndex"]);
  }

    editGrant(item: any) {
        this.$emit('editGrant', item.GrantId, item.ApplicationId);
    }

    /** check the button rights */
    checkBtnRights(field: any, record: any) {
        return this.accessRights(record, field.event);
    }

    /*** data table options  */
    get options() {
        return {
            accessRights: this.checkBtnRights
        }
    }

    get appItems() {
        return this.grants;
    }
}
